module.exports = __webpack_public_path__ + "img/Butterfly_00372.c96472fb.png";